import request from '@/utils/request'
// 活动列表
export function activityList(params) {
  return request({
    url: '/activities',
    method: 'get',
    params
  })
}
// 全部活动
export function activityAllList(params) {
  return request({
    url: '/activities/all',
    method: 'get',
    params
  })
}
// 创建活动
export function createActivity(data) {
  return request({
    url: '/activities',
    method: 'post',
    data
  })
}
// 修改活动
export function updateActivity(data) {
  return request({
    url: '/activities',
    method: 'put',
    data
  })
}
// 活动详情
export function activityDetail(id) {
  return request({
    url: '/activities/' + id,
    method: 'get'
  })
}
// 删除活动
export function deleteActivity(id) {
  return request({
    url: '/activities/' + id,
    method: 'delete'
  })
}
// 活动报名商家列表
export function activityShopList(params) {
  return request({
    url: '/activities/mcht',
    method: 'get',
    params
  })
}
// 活动报名添加商品
export function enrollActivity(data) {
  return request({
    url: '/activities/mcht/product',
    method: 'post',
    data
  })
}
// 活动商品列表
export function activityGoods(params) {
  return request({
    url: '/activities/mcht/product',
    method: 'get',
    params
  })
}
// 活动商品审核
export function activityGoodsAudit(data) {
  return request({
    url: '/activities/mcht/product',
    method: 'put',
    data
  })
}
// 退出活动
export function exitActivity(data) {
  return request({
    url: '/activities/mcht/product/exit',
    method: 'post',
    data
  })
}
// 活动楼层
export function activityFloor(actId) {
  return request({
    url: '/activities/floor/' + actId,
    method: 'get'
  })
}
// 修改活动商品楼层
export function updateActivityGoodsFloor(data) {
  return request({
    url: '/activities/mcht/product/modify/floor',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/activity.js